import * as Yup from "yup";

export const customerOverviewValidationSchema = Yup.object({
  businessName: Yup.string().required("Customer Name is required"),
  emailAddress: Yup.string()
    .email("Invalid email")
    .required("Email is required"),
  phoneNumber: Yup.string().required("Phone is required"),
  AssignedTo: Yup.array()
    .min(1, "Please assign at least one user")
    .required("Assigned User is required"),
  defaultTax: Yup.mixed()
    .transform((value) =>
      value == null || String(value).trim() === "" ? null : value,
    )
    .nullable(),
});
